import type { DependencyList } from 'react'
import { createContext, useContext, useEffect, useState } from 'react'

import type { DevAction, DevLink } from './ui/dev-menu'
import { devMenuStore } from './ui/dev-menu'
import { modalStore } from './ui/modal'
import { progressStore } from './ui/progress'
import { snackbarStore } from './ui/snackbar'
import { webviewStore } from './ui/webview'

export const ui = {
    // TODO (@cataline): remove this wrapper store
    snackbar: snackbarStore,
    modal: modalStore,
    progress: progressStore,
    devMenu: devMenuStore,
    webview: webviewStore,
}

export const UIContext = createContext<typeof ui>(ui)

interface Props {
    children: React.ReactNode
}

// TODO (@cataline): remove this
export const UIContextProvider: React.FC<Props> = ({ children }) => {
    const [store] = useState(() => ui)
    return <UIContext.Provider value={store}>{children}</UIContext.Provider>
}

/** Store for global UI element states. */
export const useUIStore = () => useContext(UIContext)

export const useDevMenuItem = (
    item: DevLink | DevAction,
    deps: DependencyList = [],
) => {
    const { devMenu } = useUIStore()

    useEffect(() => {
        devMenu.add(item)
        return () => devMenu.remove(item)
    }, deps)
}
